import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-logout',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" [attr.width]="size()" [attr.height]="size()" fill="none"
         stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
    </svg>
  `,
  styles: ``
})
export class IconLogoutComponent {
size: InputSignal<number> = input<number>(24);
}
